import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SunIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>((props, forwardedRef) => {
  return (
    <IconWrapper {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M19.7807 8.78073V4.21927H15.2193L12 1L8.78073 4.21927H4.21927V8.78073L1 12L4.21927 15.2193V19.7807H8.78073L12 23L15.2193 19.7807H19.7807V15.2193L23 12L19.7807 8.78073ZM17.8355 14.412V17.8355H14.412L12 20.2476L9.58798 17.8355H6.16446V14.412L3.75243 12L6.16446 9.58798V6.16446H9.58798L12 3.75243L14.412 6.16446H17.8355V9.58798L20.2476 12L17.8355 14.412ZM12 6.65075C9.05305 6.65075 6.65075 9.05305 6.65075 12C6.65075 14.9469 9.05305 17.3492 12 17.3492C14.9469 17.3492 17.3492 14.9469 17.3492 12C17.3492 9.05305 14.9469 6.65075 12 6.65075ZM12 15.4041C10.1229 15.4041 8.59593 13.8771 8.59593 12C8.59593 10.1229 10.1229 8.59593 12 8.59593C13.8771 8.59593 15.4041 10.1229 15.4041 12C15.4041 13.8771 13.8771 15.4041 12 15.4041Z"
          fill="#222"
        />
      </svg>
    </IconWrapper>
  )
})
